import { useEffect, useState, useContext } from 'react';
import Button from "@mui/material/Button"
import { Box, Container, CssBaseline } from "@mui/material";
import Typography from '@mui/material/Typography';
import { sendEmailVerification } from 'firebase/auth';
import { AuthContext } from '../contexts/authContext';
import {IconButton} from '@mui/material/node';
import XIcon from '@mui/icons-material/X';

export const Confirm = () => {
    const [timeLeft, setTimeLeft] = useState(60);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        if (timeLeft === 0) {
            setTimeLeft(null)
        }

        if (!timeLeft) return;

        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);

        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    const sendConfirmation = async (event) => {
        sendEmailVerification(user);
        setTimeLeft(60);
    }

    return (

        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                }}
            >
                <CssBaseline />

                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Typography component="h1" variant="h3">
                        NodeCanvas
                    </Typography>
                    <Typography component="h1" variant="h6" sx={{ mt: 2 }}>
                        Thank you for your registration.
                    </Typography>

                    <Typography variant="body" sx={{ mt: 6 }} align="center">
                        We've sent a confirmation link to your email address. <br />
                        Please click the link in the email to verify your account and continue.<br />
                        <br />
                        Didn't receive the email?
                        Make sure to check your spam or junk folder. <br /><br />You can also request a new confirmation email.
                    </Typography>

                    <Button onClick={sendConfirmation} sx={{ mt: 6 }} disabled={(timeLeft !== null)}>
                        {(timeLeft === null) && "Send again"}
                        {(timeLeft !== null) && `Send again (wait ${timeLeft} seconds)`}
                    </Button>
                    <Typography variant="body" sx={{ mt: 6}} align="center">
                        Still have a problem? Get in touch with me<br />
                        <IconButton onClick={()=> window.open("https://x.com/duchanito", "_blank")} sx={{ mt: 2}}><XIcon /></IconButton>
                    </Typography>
                </Box>
            </Box>
        </Container>
    )
}